// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum CustomerQuestionnaireAnswerProp {
	Answer = 'answer',
	Answer$list = 'answer$list',
	AnswerName = 'answer.name',
	AnswerScore = 'answer.score',
	AnswerShortName = 'answer.shortName',
	ComplianceDataCustomerId = 'complianceData.customer.id',
	Description = 'description',
	Id = 'id',
	OtherAnswer = 'otherAnswer',
	QuestionName = 'question.name',
	QuestionShortName = 'question.shortName',
	UserApprovalApprovalDate = 'userApproval.approvalDate',
	UserApprovalApprovedByLoginName = 'userApproval.approvedBy.loginName',
	UserApprovalStatus = 'userApproval.status'
}

export type CustomerQuestionnaireAnswerPropAnswer = {
	[CustomerQuestionnaireAnswerProp.Answer] : any /* Entity */
}
export type CustomerQuestionnaireAnswerPropAnswer$list = {
	[CustomerQuestionnaireAnswerProp.Answer$list] : any /* Entity */
}
export type CustomerQuestionnaireAnswerPropAnswerName = {
	[CustomerQuestionnaireAnswerProp.AnswerName] : string | null
}
export type CustomerQuestionnaireAnswerPropAnswerScore = {
	[CustomerQuestionnaireAnswerProp.AnswerScore] : number | null
}
export type CustomerQuestionnaireAnswerPropAnswerShortName = {
	[CustomerQuestionnaireAnswerProp.AnswerShortName] : string | null
}
export type CustomerQuestionnaireAnswerPropComplianceDataCustomerId = {
	[CustomerQuestionnaireAnswerProp.ComplianceDataCustomerId] : number | null
}
export type CustomerQuestionnaireAnswerPropDescription = {
	[CustomerQuestionnaireAnswerProp.Description] : string | null
}
export type CustomerQuestionnaireAnswerPropId = {
	[CustomerQuestionnaireAnswerProp.Id] : number
}
export type CustomerQuestionnaireAnswerPropOtherAnswer = {
	[CustomerQuestionnaireAnswerProp.OtherAnswer] : string | null
}
export type CustomerQuestionnaireAnswerPropQuestionName = {
	[CustomerQuestionnaireAnswerProp.QuestionName] : string | null
}
export type CustomerQuestionnaireAnswerPropQuestionShortName = {
	[CustomerQuestionnaireAnswerProp.QuestionShortName] : string | null
}
export type CustomerQuestionnaireAnswerPropUserApprovalApprovalDate = {
	[CustomerQuestionnaireAnswerProp.UserApprovalApprovalDate] : number | null
}
export type CustomerQuestionnaireAnswerPropUserApprovalApprovedByLoginName = {
	[CustomerQuestionnaireAnswerProp.UserApprovalApprovedByLoginName] : string | null
}
export type CustomerQuestionnaireAnswerPropUserApprovalStatus = {
	[CustomerQuestionnaireAnswerProp.UserApprovalStatus] : 'PENDING' | 'IN_PROGRESS' | 'REJECTED' | 'APPROVED' | null
}


export type CustomerQuestionnaireAnswer = 
	CustomerQuestionnaireAnswerPropAnswer & 
	CustomerQuestionnaireAnswerPropAnswer$list & 
	CustomerQuestionnaireAnswerPropAnswerName & 
	CustomerQuestionnaireAnswerPropAnswerScore & 
	CustomerQuestionnaireAnswerPropAnswerShortName & 
	CustomerQuestionnaireAnswerPropComplianceDataCustomerId & 
	CustomerQuestionnaireAnswerPropDescription & 
	CustomerQuestionnaireAnswerPropId & 
	CustomerQuestionnaireAnswerPropOtherAnswer & 
	CustomerQuestionnaireAnswerPropQuestionName & 
	CustomerQuestionnaireAnswerPropQuestionShortName & 
	CustomerQuestionnaireAnswerPropUserApprovalApprovalDate & 
	CustomerQuestionnaireAnswerPropUserApprovalApprovedByLoginName & 
	CustomerQuestionnaireAnswerPropUserApprovalStatus

export const CUSTOMER_QUESTIONNAIRE_ANSWER_PROPERTY_NAMES = Object.freeze([CustomerQuestionnaireAnswerProp.Answer, CustomerQuestionnaireAnswerProp.Answer$list, CustomerQuestionnaireAnswerProp.AnswerName, CustomerQuestionnaireAnswerProp.AnswerScore, CustomerQuestionnaireAnswerProp.AnswerShortName, CustomerQuestionnaireAnswerProp.ComplianceDataCustomerId, CustomerQuestionnaireAnswerProp.Description, CustomerQuestionnaireAnswerProp.Id, CustomerQuestionnaireAnswerProp.OtherAnswer, CustomerQuestionnaireAnswerProp.QuestionName, CustomerQuestionnaireAnswerProp.QuestionShortName, CustomerQuestionnaireAnswerProp.UserApprovalApprovalDate, CustomerQuestionnaireAnswerProp.UserApprovalApprovedByLoginName, CustomerQuestionnaireAnswerProp.UserApprovalStatus])

export type CustomerQuestionnaireAnswerEdit = 
	CustomerQuestionnaireAnswerPropId & 
	CustomerQuestionnaireAnswerPropQuestionName & 
	CustomerQuestionnaireAnswerPropQuestionShortName & 
	CustomerQuestionnaireAnswerPropAnswerShortName & 
	CustomerQuestionnaireAnswerPropAnswerName & 
	CustomerQuestionnaireAnswerPropOtherAnswer & 
	CustomerQuestionnaireAnswerPropAnswerScore & 
	CustomerQuestionnaireAnswerPropAnswer$list & 
	CustomerQuestionnaireAnswerPropAnswer & 
	CustomerQuestionnaireAnswerPropUserApprovalApprovedByLoginName & 
	CustomerQuestionnaireAnswerPropUserApprovalApprovalDate & 
	CustomerQuestionnaireAnswerPropUserApprovalStatus & 
	CustomerQuestionnaireAnswerPropDescription

export const CUSTOMER_QUESTIONNAIRE_ANSWER_EDIT_PROPERTY_NAMES = Object.freeze([CustomerQuestionnaireAnswerProp.Id, CustomerQuestionnaireAnswerProp.QuestionName, CustomerQuestionnaireAnswerProp.QuestionShortName, CustomerQuestionnaireAnswerProp.AnswerShortName, CustomerQuestionnaireAnswerProp.AnswerName, CustomerQuestionnaireAnswerProp.OtherAnswer, CustomerQuestionnaireAnswerProp.AnswerScore, CustomerQuestionnaireAnswerProp.Answer$list, CustomerQuestionnaireAnswerProp.Answer, CustomerQuestionnaireAnswerProp.UserApprovalApprovedByLoginName, CustomerQuestionnaireAnswerProp.UserApprovalApprovalDate, CustomerQuestionnaireAnswerProp.UserApprovalStatus, CustomerQuestionnaireAnswerProp.Description])

export type CustomerQuestionnaireAnswerHistoryTab = 
	CustomerQuestionnaireAnswerPropId & 
	CustomerQuestionnaireAnswerPropComplianceDataCustomerId

export const CUSTOMER_QUESTIONNAIRE_ANSWER_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([CustomerQuestionnaireAnswerProp.Id, CustomerQuestionnaireAnswerProp.ComplianceDataCustomerId])
